module.exports = __webpack_public_path__ + "static/media/site-builder-v2.c168956a.png";